/** Section keys used in HrInformationBody conditional rendering */
export const HR_REPORT_SECTIONS = {
    ORG_UNIT: 'orgUnit',
    POSITION: 'position',
    AGE: 'age',
    FOR_DATE: 'forDate',
    BORN_TO: 'bornTo',
    PERIOD: 'period',
    LENGTH_OF_SERVICE: 'lengthOfService',
    ADDITIONAL_COLUMNS: 'additionalColumns',
    ORDERED_BY: 'orderedBy',
};


export const HR_INFORMATION_OPTION_KEYS = [
    { value: 'employees-retirement-age', labelKey: 'staff.hrInformation.options.employeesWithAchievedAge' },
    { value: 'employees-term-contracts', labelKey: 'staff.hrInformation.options.employeesWithTemporaryContracts' },
    { value: 'employees-permanent-contracts', labelKey: 'staff.hrInformation.options.employeesWithPermanentContracts' },
    { value: 'ratio-women-personnel', labelKey: 'staff.hrInformation.options.percentageOfWomenRegardingEmployedStaff' },
    { value: 'number-of-employees', labelKey: 'staff.hrInformation.options.numberOfEmployees' },
    { value: 'average-monthly-salary', labelKey: 'staff.hrInformation.options.averageSalary' },
    { value: 'employee-list', labelKey: 'staff.hrInformation.options.employeeList' },
    { value: 'employee-length-of-service', labelKey: 'staff.hrInformation.options.workExperienceOfEmployees' },
    { value: 'average-number-of-employees', labelKey: 'staff.hrInformation.options.averageStaff' },
    { value: 'terminated-employees', labelKey: 'staff.hrInformation.options.leftEmployees' },
    { value: 'appointed-employees', labelKey: 'staff.hrInformation.options.newEmployees' },
    { value: 'personnel-movement', labelKey: 'staff.hrInformation.options.hrInformationAboutTheCompositionAndMovementOfStaff' },
    { value: 'form-nsi', labelKey: 'staff.hrInformation.options.hrInformationAboutTheCompletionOfFormForNsi' },
    { value: 'length-of-service-allowance-percentages', labelKey: 'staff.hrInformation.options.percentageOfEmployeesChanges' },
    { value: 'personnel-table', labelKey: 'staff.hrInformation.options.hourlySchedule' },
    { value: 'job-table', labelKey: 'staff.hrInformation.options.hourlyScheduleOfPositions' },
    { value: 'pensions-social-security', labelKey: 'staff.hrInformation.options.pensionHistory' },
    { value: 'reduced-working-capacity', labelKey: 'staff.hrInformation.options.employeesWithReducedWorkability' },
    { value: 'employees-retired', labelKey: 'staff.hrInformation.options.employeesRetired' },
    { value: 'changed-working-day-duration', labelKey: 'staff.hrInformation.options.employeesWithChangedWorkdayDuration' },
    { value: 'structural-group-history', labelKey: 'staff.hrInformation.options.structuralGroupChangeHistory' },
    { value: 'cost-center-history', labelKey: 'staff.hrInformation.options.positionCostCenterChangeHistory' },
    { value: 'position-occupants-history', labelKey: 'staff.hrInformation.options.occupyingPositionChangeHistory' },
    { value: 'rights-of-position', labelKey: 'staff.hrInformation.options.positionRights' },
    { value: 'positions-held-history', labelKey: 'staff.hrInformation.options.positionsOccupiedByEmployees' },
    { value: 'employees-insurance-type', labelKey: 'staff.hrInformation.options.employeesInsuranceType' },
    { value: 'employee-children-under-19', labelKey: 'staff.hrInformation.options.childrenOfEmployeesUnder19YearsOld' },
    { value: 'dc-salary-change-from-file', labelKey: 'staff.hrInformation.options.generatedDsForChangeOfSalaryFromFile' },
    { value: 'employee-bank-accounts-as-of-date', labelKey: 'staff.hrInformation.options.bankAccountsOfEmployeesAtDate' },
];

export function getHrInformationOptions(t) {
    return HR_INFORMATION_OPTION_KEYS.map(({ value, labelKey }) => ({
        value,
        label: t(labelKey),
    }));
}

const S = HR_REPORT_SECTIONS;

/** Visible sections per report type — extend as you add more reports */
export const HR_REPORT_SECTIONS_BY_TYPE = {
    'employees-retirement-age': [S.FOR_DATE, S.AGE, S.ORG_UNIT, S.ORDERED_BY], //✅
    'employees-term-contracts': [S.FOR_DATE, S.ORG_UNIT, S.ORDERED_BY],//✅
    'employees-permanent-contracts': [S.FOR_DATE, S.ORG_UNIT, S.ORDERED_BY],//✅
    'ratio-women-personnel': [S.FOR_DATE, S.ORG_UNIT],//✅
    'number-of-employees': [S.FOR_DATE, S.ORG_UNIT],//✅
    'average-monthly-salary': [S.FOR_DATE, S.ORG_UNIT],//✅
    'employee-list': [S.FOR_DATE, S.ORG_UNIT, S.ORDERED_BY, S.ADDITIONAL_COLUMNS],//✅
    'employee-length-of-service': [S.FOR_DATE, S.LENGTH_OF_SERVICE, S.ORG_UNIT, S.ORDERED_BY],//✅
    'average-number-of-employees': [S.FOR_DATE, S.ORG_UNIT], // TODO: EMPTY FOR NOW
    'terminated-employees': [S.PERIOD, S.ORG_UNIT, S.ORDERED_BY],//✅
    'appointed-employees': [S.PERIOD, S.ORG_UNIT, S.ORDERED_BY], //✅
    'personnel-movement': [S.PERIOD, S.ORG_UNIT],  //✅
    'form-nsi': [S.FOR_DATE, S.ORG_UNIT],  //✅
    'length-of-service-allowance-percentages': [S.FOR_DATE, S.ORG_UNIT, S.ORDERED_BY],  // TODO: EMPTY FOR NOW
    'personnel-table': [S.FOR_DATE, S.ORG_UNIT],  //✅
    'job-table': [S.FOR_DATE, S.ORG_UNIT],  //✅
    'pensions-social-security': [S.BORN_TO, S.ORG_UNIT, S.ORDERED_BY],  // TODO: EMPTY FOR NOW
    'reduced-working-capacity': [S.PERIOD, S.ORG_UNIT, S.ORDERED_BY], //✅
    'employees-retired': [S.PERIOD, S.ORG_UNIT, S.ORDERED_BY],
    'changed-working-day-duration': [S.PERIOD, S.ORG_UNIT, S.ORDERED_BY],
    'structural-group-history': [S.PERIOD, S.ORG_UNIT],  //✅
    'cost-center-history': [S.PERIOD, S.ORG_UNIT, S.POSITION],  //✅
    'position-occupants-history': [S.PERIOD, S.ORG_UNIT, S.POSITION],  //✅
    'rights-of-position': [S.FOR_DATE, S.ORG_UNIT, S.POSITION],  //✅
    'positions-held-history': [S.PERIOD, S.ORG_UNIT, S.ORDERED_BY],  //✅
    'employees-insurance-type': [S.FOR_DATE, S.ORG_UNIT, S.ORDERED_BY],  //✅
    'employee-children-under-19': [S.FOR_DATE, S.ORG_UNIT, S.ORDERED_BY],  //✅
    'dc-salary-change-from-file': [S.PERIOD, S.ORG_UNIT],  //✅
    'employee-bank-accounts-as-of-date': [S.FOR_DATE, S.ORG_UNIT, S.ORDERED_BY],  //✅
};

export function getVisibleSections(reportKey) {
    return HR_REPORT_SECTIONS_BY_TYPE[reportKey] ?? [];
}

export function isSectionVisible(reportKey, sectionKey) {
    return getVisibleSections(reportKey).includes(sectionKey);
}
